import { LocalizedText, UseDialogActionReturn } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { PortfolioEnterpriseGroupResult } from '@mews-commander/data-access';
import { Dialog } from '@optimus-web/core';

interface DeletePropertyGroupsDialogProps {
    propertyGroups: PortfolioEnterpriseGroupResult[];
    deleteAction: UseDialogActionReturn;
}

export const DeletePropertyGroupsDialog = ({ propertyGroups, deleteAction }: DeletePropertyGroupsDialogProps) => (
    <Dialog
        title={
            propertyGroups.length === 1 ? (
                <LocalizedText
                    textKey={TextKey.PropertyGroupDeleteSingleTitle}
                    substitutes={{ propertyGroupName: propertyGroups[0].name }}
                />
            ) : (
                <LocalizedText textKey={TextKey.PropertyGroupDeleteBulkTitle} />
            )
        }
        actions={[
            {
                children: <LocalizedText textKey={TextKey.Cancel} />,
                onClick: deleteAction.handlers.handleCancel,
                variant: 'tertiary',
                size: 'medium',
                type: 'button',
            },
            {
                children: <LocalizedText textKey={TextKey.Delete} />,
                onClick: deleteAction.handlers.handleConfirm,
                variant: 'destructive',
                size: 'medium',
                type: 'submit',
            },
        ]}
        active
        loading={deleteAction.states.isProcessing}
        onClose={deleteAction.handlers.handleCancel}
    >
        {propertyGroups.length === 1 ? (
            <LocalizedText
                textKey={TextKey.PropertyGroupDeleteSingleDescription}
                substitutes={{ propertyGroupName: propertyGroups[0].name }}
            />
        ) : (
            <LocalizedText textKey={TextKey.PropertyGroupDeleteBulkDescription} />
        )}
    </Dialog>
);
